/**
 * Takes a single story and prepares it for use
 * @author Denis Sobolev, Brendan Magee, Vinny DeFrancesco, Ryan Gladstone
 */

function storyProcessingService(
  $http,
  $q,
  $sce,
  $translate,
  _,
  moment,
  analyticsService,
  platformService,
) {
  const service = {};

  // Clean the headline & body of unsafe html
  // We tried switching to $sce.getTrustedHtml, but breaks the app if the API
  // returned invalid HTML
  // Perhaps we just need to try getTrustedHtml and skip the story if parsing fails
  service.trustHeadlineAndBody = (currentStory) => {
    const story = angular.copy(currentStory);

    if (!story.websked) {
      story.websked = {};
    }

    if (story.headline !== null && typeof story.headline === 'string') {
      story.websked.headline_clean = $sce.trustAsHtml(story.headline);
    }

    story.websked.html_clean = $sce.trustAsHtml(story.html);

    return story;
  };

  service.processCreators = (creators) => {
    // creators should be null if none are listed
    if (creators === undefined || creators === null || creators.length === 0) {
      return null;
    }
    return creators;
  };

  service.cleanStory = (incomingStory, platform) => {
    let story = incomingStory;

    // keep the time break
    story.websked = _.merge({}, story.websked);

    story = service.trustHeadlineAndBody(story);

    story.creators = service.processCreators(story.creators);

    service.setOldPitchInfo(story, platform);

    // translate the contentType of the story
    story.contentType = service.getContentType(story.contentType);

    // translate the pitchStatus of the story
    if (
      story.websked
      && story.websked.pitch
      && story.websked.pitch.pitchStatus
    ) {
      const { pitch } = story.websked;
      story.websked.pitch.displayPitchStatus =
        service.convertPitchStatusToDisplayPitchStatus(pitch.pitchStatus);
    }

    return story;
  };

  service.setOldPitchInfo = (currentStory, platform) => {
    const story = currentStory;

    angular.forEach(story.pitches, (currentPitch, k) => {
      const pitch = currentPitch;
      pitch.planName = platformService.getPlatformName(pitch.planPath);

      // Check for relevant pitches if user is currently viewing an open plan
      if (platform === pitch.planPath) {
        const lastEvent = story.pitches[k].events[story.pitches[k].events.length - 1];
        story.websked.pitch = {
          planPath: platform,
          person: lastEvent.person,
          pitchStatus: lastEvent.pitchStatus,
          note: lastEvent.note,
          datetime: lastEvent.datetime
        };
      }
    });
  };

  service.addTimebreaksToList = (list) => {
    _.each(list, (currentStory, index) => {
      const story = currentStory;
      const previousStory = index ? list[index - 1] : null;

      if (!previousStory) {
        return undefined;
      }

      const currentStoryDate = moment(story.dates.websked * 1000);
      const previousStoryDate = moment(previousStory.dates.websked * 1000);
      if (currentStoryDate.date() !== previousStoryDate.date()) {
        story.websked.timebreak = { dayBreak: true };
      } else if (Math.abs(previousStoryDate.hour() - currentStoryDate.hour()) > 1) {
        story.websked.timebreak = { hourGap: true };
      } else if (Math.abs(previousStoryDate.hour() - currentStoryDate.hour()) === 1) {
        story.websked.timebreak = { hourIncrement: true };
      }

      return undefined;
    });
  };

  service.getContentType = (contentType) => {
    let result;

    switch (contentType) {
      case 'article':
        result = $translate.instant('ARTICLE');
        break;
      case 'video':
        result = $translate.instant('VIDEO');
        break;
      case 'gallery':
        result = $translate.instant('GALLERY');
        break;
      case 'graphic':
        result = $translate.instant('GRAPHIC');
        break;
      default:
        result = contentType;
        break;
    }

    return result;
  };

  service.convertPitchStatusToDisplayPitchStatus = (status) => {
    let displayStatus;

    switch (status) {
      case 'pitched':
        displayStatus = $translate.instant('PITCHED');
        break;
      case 'watching':
        displayStatus = $translate.instant('WATCHING');
        break;
      case 'not watching':
        displayStatus = $translate.instant('NOT_WATCHING');
        break;
      case 'saving':
        displayStatus = $translate.instant('SAVING');
        break;
      case 'used':
        displayStatus = $translate.instant('USED');
        break;
      case 'withdrawn':
        displayStatus = $translate.instant('WITHDRAWN');
        break;
      default:
        displayStatus = status;
        break;
    }

    return displayStatus;
  };

  service.updateEta = (story, newEta) => {
    const deferred = $q.defer();

    $http.post('/editorial-search/update', {
      id: story.id,
      field: 'planning.scheduling.planned_publish_date',
      value: newEta.toISOString().replace('.000Z', 'Z')
    }).success((data) => {
      analyticsService.trackEvent('Story action', story.dates.websked ? 'Story ETA updated' : 'Updated time to Web');
      deferred.resolve(data);
    }).error((data) => {
      deferred.reject(data);
    });

    return deferred.promise;
  };

  return service;
}

const arr = [
  '$http',
  '$q',
  '$sce',
  '$translate',
  '_',
  'moment',
  'analyticsService',
  'platformService',
  storyProcessingService
];

module.exports = (ngModule) => {
  ngModule.service('storyProcessingService', arr);
};

